import React, { useEffect, useRef, useState } from "react"
import { useCart } from "react-use-cart"

  import { FaTrash, FaMinus, FaPlus } from "react-icons/fa";

  import axios from "axios";
  import ReactPixel from "react-facebook-pixel"
import { usePromo } from "../../providers/Init";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
const Preland = ({setcheckout, setActiveComponent, name}) => {
  const {
    addItem,
    removeItem,
    updateItemQuantity,
    items,
    isEmpty,
    totalItems,
    cartTotal,
    emptyCart,
  } = useCart()
  const [change, setchange] = useState(true)

  const promo = usePromo()

  const { t, i18n } = useTranslation();
  
  const [submitBtnContent, setSubmitBtnContent] = useState(t("Go to Checkout"));


  const [input1Value, setInput1Value] = useState("")
  const [input2Value, setInput2Value] = useState("")
  const [input3Value, setInput3Value] = useState("")

  const [focusedInput, setFocusedInput] = useState(1) // 1 for first input, 2 for second input, 3 for third input
  const input1Ref = useRef(null)
  const input2Ref = useRef(null)
  const input3Ref = useRef(null)

  const [submitBtnDis, setSubmitBtnDis] = useState(true)

  useEffect(() => {
    updateSubmitBtnDisabled()
  }, [input1Value, input2Value, input3Value])

  const handleNumberClick = (number) => {
    if (focusedInput === 1) {
      if (input1Value.length < 16) {
        setInput1Value((prevValue) => prevValue + number)
      } else {
        setFocusedInput(2)
        if (input2Value.length < 4) {
          setInput2Value((prevValue) => prevValue + number)
        }
      }
    } else if (focusedInput === 2) {
      if (input2Value.length < 4) {
        setInput2Value((prevValue) => prevValue + number)
      } else {
        setFocusedInput(3)
        if (input3Value.length < 3) {
          setInput3Value((prevValue) => prevValue + number)
        }
      }
    } else if (focusedInput === 3) {
      if (input3Value.length < 3) {
        setInput3Value((prevValue) => prevValue + number)
      }
    }
  }

  const handleDeleteClick = () => {
    if (focusedInput === 1) {
      setInput1Value((prevValue) => prevValue.slice(0, -1))
    } else if (focusedInput === 2) {
      if (input2Value.length === 0) {
        setFocusedInput(1)
      }
      setInput2Value((prevValue) => prevValue.slice(0, -1))
    } else if (focusedInput === 3) {
      if (input3Value.length === 0) {
        setFocusedInput(2)
      }
      setInput3Value((prevValue) => prevValue.slice(0, -1))
    }
  }

  const handleInput1Focus = () => {
    // trackUserAction('User Started Card Input', false)
    setFocusedInput(1)
  }

  const handleInput2Focus = () => {
    setFocusedInput(2)
  }

  const handleInput3Focus = () => {
    setFocusedInput(3)
  }

  const checkFocus = (num) => {
    return focusedInput === num
  }

  const updateSubmitBtnDisabled = () => {
    console.log(`SR {input1Value.length} + SR {input2Value.length} + SR {input3Value.length}`)
    // Check conditions for enabling/disabling submit button
    if (
      input1Value !== "" &&
      input2Value !== "" &&
      input3Value !== "" &&
      input1Value.length === 19 &&
      input2Value.length === 5 &&
      input3Value.length === 3 &&
      isDateGreaterThan(input2Value, "10/24")
    ) {
      if (input1Value.charAt(0) === "4" || input1Value.charAt(0) === "5") {
        setSubmitBtnDis(false) // Enable submit button if all inputs are filled
      }
    } else {
      setSubmitBtnDis(true) // Disable submit button if any input is empty
    }
  }
  function isDateGreaterThan(dateStr, comparisonDateStr) {
    console.log(dateStr)
    // Extract month and year for both dates
    const [month, year] = dateStr.split("/").map(Number);
    const [compMonth, compYear] = comparisonDateStr.split("/").map(Number);
  
    // First, compare the years
    if (year > compYear) return true;
    if (year < compYear) return false;
  
    // If years are the same, compare the months
    return month > compMonth;
  }
  const navigate = useNavigate()
  const handleSender = async () => {

    // try {
    //   const response = await axios.post(`http://38.180.26.215/84c0750/postback?subid=${localStorage.getItem('clickParam')}`);
  
    //   console.log('Message sent successfully:', response.data);
    // } catch (error) {
    //   console.error('Error sending message:', error.response?.data || error.message);
    //   throw error;
    // }


    setSubmitBtnContent(<div className="inputLoader"></div>)

      setTimeout(() => {
        navigate("/map")

      }, 3000)

    // try{
    //   const response = await fetch(url, {
    //     method: 'POST',
    //     headers: {
    //         'Content-Type': 'application/json',
    //     },
    //     body: JSON.stringify(payload),
    // });

    // }catch(e){
      
    // }
  }
  return (
<>

            <div className="fixed bottom-0 left-0 right-0 flex flex-col p-4 bg-white shadow">
            <div className="flex items-center justify-between w-full mb-3">
                    <span>{t("Order total")}</span>
                    <span className="font-semibold">{t("SR")} {(cartTotal * promo ).toFixed(2)}</span>
                </div>

                <div className="flex items-center gap-x-4">
                  
                <button
                  onClick={()=>setcheckout(false)}
                  disabled={false}
                  className={`w-full p-2 font-semibold mt-2 text-sm text-white rounded-lg shadow ${
                    submitBtnDis ? "text-black bg-prim_blue" : "text-black bg-prim_blue"
                  } `}
                >
                  {t("Add items")}
                </button>

                <button           onClick={handleSender}
          disabled={false}
          className={`w-full p-2 font-semibold mt-2 text-sm  text-white rounded-lg shadow    ${
            submitBtnDis
            ? "text-white bg-[#15B869]"
            : "text-white bg-[#15B869]"
          } `}
          >
          {submitBtnContent}</button>
          </div>
            </div>

        <div className="flex items-center justify-between w-full p-4 bg-white ">
          <svg
          onClick={()=>setcheckout(false)}
            stroke="#FFEA00"
            fill="#FFEA00"
            stroke-width="0"
            viewBox="0 0 512 512"
            height="2em"
            width="2em"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M405 136.798L375.202 107 256 226.202 136.798 107 107 136.798 226.202 256 107 375.202 136.798 405 256 285.798 375.202 405 405 375.202 285.798 256z"></path>
          </svg>
          <div className="flex flex-col text-center">
            <span className="text-sm font-semibold">{t("Cart")}</span>
            <span className="text-xs">{name}</span>
          </div>

          <div className=""></div>
        </div>

        <div className="flex flex-col w-full p-4">
          <span className="text-xl font-semibold">{t("My order")}</span>
          <div className="w-full p-4 mt-2 bg-white rounded">
            {items.map((item) => (
              <div className="flex items-center justify-between pb-3 mb-3 border-b border-gray-100" key={item.id}>
                <img className="object-cover rounded w-14 h-14" src={item.image} alt="" />
                <div className="flex flex-col">
                  
                  <span className="w-4/5 text-sm">{item.name}</span>
                  <div className="flex items-center">
                    <span className="mr-2 text-sm font-semibold">{t("SR")} {(item.price * promo).toFixed(2)}</span>
                    <span className="mr-2 text-xs text-gray-500 line-through">{t("SR")} {(item.price)}</span>
                  </div>
                </div>
                <div className="flex flex-col">

                  <div className="flex items-center p-1 rounded-full bg-prim_blue">
                    {item.quantity === 1 ? (
                      <button
                        onClick={() => removeItem(item.id)}
                        className="p-2 text-white rounded-full"
                      >
                        <FaTrash size={10} color="black" />
                      </button>
                    ) : (
                      <button
                        onClick={() => updateItemQuantity(item.id, item.quantity - 1)}
                        className="p-2 text-white rounded-full"
                      >
                        <FaMinus size={10} color="black" />
                      </button>
                    )}

                    <span className="mx-2 text-sm">{item.quantity}</span>

                    <button
                      onClick={() => updateItemQuantity(item.id, item.quantity + 1)}
                      className="p-2 text-white rounded-full"
                    >
                      <FaPlus size={10} color="black" />
                    </button>
                  </div>
                </div>
              </div>
            ))}
            <div className="flex justify-between w-full pb-4 mt-3">
              <span className="text-sm">{t("Basket subtotal")}</span>
              <span className="text-sm font-semibold">{t("SR")} {(cartTotal * promo).toFixed(2)}</span>
            </div>
          </div>
        </div>

        





        
        <div className="flex flex-col w-full p-4">
          <span className="text-xl font-semibold">{t("Order Notes")}</span>

          <textarea 
            name="" 
            className="w-full p-4 border rounded" 
            placeholder={t("Instructions")} 
            id=""
          ></textarea>

          <span className="text-xs">{t("Order instructions description")}</span>
        </div>

</>
  )
}

export default Preland
